import { buildApiUrl } from "../lib/api";
import { getAuthHeaders } from "./auth";

export async function getMatnrForContract(contract: string, contractPos: string): Promise<string | null> {
    const url = buildApiUrl("/api/zhb-t13", { VERTRAG: contract, VERTRAGSPOSITION: contractPos });
    const response = await fetch(url, {
        headers: getAuthHeaders(),
        credentials: "include"
    });
    if (!response.ok) return null;
    const data = await response.json();
    if (Array.isArray(data) && data.length > 0 && data[0].MATNR) {
        return data[0].MATNR;
    }
    return null;
}

export async function getSortimentNameForMatnr(matnr: string): Promise<string | null> {
    const url = buildApiUrl("/api/zhb-t13t", { MATNR: matnr, SPRAS: "D" });
    const response = await fetch(url, {
        headers: getAuthHeaders(),
        credentials: "include"
    });
    if (!response.ok) return null;
    const data = await response.json();
    if (Array.isArray(data) && data.length > 0 && data[0].MAKTX) {
        return data[0].MAKTX;
    }
    return null;
}
